<template>
  <!-- <AppNavbar /> -->
  <SearchWidget />
  <!-- <AppRoutes /> -->
  <br />
  <!-- <AppFooter /> -->
</template>

<script>
// import AppNavbar from "../components/AppNavbar.vue";
// import AppFooter from "../components/AppFooter.vue";
import SearchWidget from "../components/searchwidget.vue";
// import AppRoutes  from "../components/AppRoutes.vue";

export default {
 name: "HomePage",
   components: {
    // AppNavbar,
    SearchWidget,
    // AppFooter,
    // AppRoutes,
      // name: "PopularRoutes",

  },
  mounted() {
    // Check if we need to scroll to a specific section
    if (this.$route.query.scrollTo) {
      this.$nextTick(() => {
        this.scrollToSection(this.$route.query.scrollTo);
      });
    }
  },
  methods: {
    scrollToSection(sectionId) {
      // Add a small delay to ensure page has loaded before scrolling
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          // For "about" section, use a larger offset to account for hero section
          const headerOffset = sectionId === 'about' ? 400 : 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 200);
    }
  },
  watch: {
    // Watch for changes in route query parameters
    '$route.query.scrollTo'(newSection) {
      if (newSection) {
        this.$nextTick(() => {
          this.scrollToSection(newSection);
        });
      }
    }
  }


};
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
